module.exports = __webpack_public_path__ + "static/media/coverImg01.ffc7027e.png";